import { z } from "zod";

const DataSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    email: z.string().email(),
    email_verified_at: z.nullable(z.string()), // ISO date string or null
    created_at: z.string(), // ISO date string
    updated_at: z.string(), // ISO date string
    channex_user_api_key: z.nullable(z.string()).optional(),
    username: z.nullable(z.string()).optional(),
    phone: z.nullable(z.string()),
    permissions: z.array(z.string()), // Array of permissions as strings
    role: z.array(z.string()), // Array of roles as strings
    active_property: z.nullable(z.string()),
    active_property_id: z.nullable(z.string().uuid()),
    is_full_sync: z.boolean(),
    properties: z.record(z.string().uuid(), z.string()), // Record of property IDs and names
});

export const ProfileResponse = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: DataSchema,
});

// Example TypeScript type inference
export type ProfileResponseType = z.infer<typeof ProfileResponse>;